<template>
    <div id="filter-removal-content" ref="tooltipRef">
        <form action class="filter-popover">
            <p>{{ message }}</p>
            <ui-spinner-grow
                v-if="loadingStatus === 'loading'"
                class="mb-2"
                :small="true"
            />
            <div
                class="filter-popover__buttons d-flex gap-0-5 flex-wrap justify-content-center"
            >
                <button
                    v-if="!hideConfirmBtn && closeOnConfirm"
                    type="button"
                    @click="confirm"
                    v-close-popover
                    class="btn mr-1 btn-sm btn-secondary"
                    :id="confirmBtnId"
                >
                    {{ confirmText }}
                </button>
                <button
                    v-else-if="!hideConfirmBtn"
                    type="button"
                    @click="confirm"
                    class="btn mr-1 btn-sm btn-secondary"
                    :id="confirmBtnId"
                >
                    {{ confirmText }}
                </button>
                &nbsp;&nbsp;
                <button
                    v-if="!hideAbortBtn && !noCloseOnAbort"
                    type="button"
                    v-close-popover
                    @click="abort"
                    :class="abortBtnClass"
                    :id="abortBtnId"
                >
                    {{ abortText }}
                </button>
                <button
                    v-else-if="!hideAbortBtn"
                    type="button"
                    @click="abort"
                    :class="abortBtnClass"
                    :id="abortBtnId"
                >
                    {{ abortText }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'popoverConfirm',
    props: {
        message: {
            type: String,
            default: 'Czy na pewno usunąć?'
        },
        abortText: {
            type: String,
            default: 'Anuluj'
        },
        confirmText: {
            type: String,
            default: 'Tak'
        },
        abortBtnId: {
            type: String
        },
        confirmBtnId: {
            type: String
        },
        closeOnConfirm: {
            type: Boolean,
            default: true
        },
        noCloseOnAbort: {
            type: Boolean,
            default: false
        },
        loadingStatus: {
            type: String
        },
        hideAbortBtn: {
            type: Boolean,
            default: false
        },
        hideConfirmBtn: {
            type: Boolean,
            default: false
        },
        abortBtnClass: {
            type: String,
            default: 'btn btn-sm btn-danger'
        }
    },
    methods: {
        confirm() {
            this.$emit('confirmed')
        },
        abort() {
            this.$emit('aborted')
        }
    }
}
</script>
